import { Component, OnInit, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { NavbarService } from '../navbar/navbar.service';
declare let jsPDF;

@Component({
  selector: 'app-quotedocument',
  templateUrl: './quotedocument.component.html',
  styleUrls: ['./quotedocument.component.css']
})
export class QuotedocumentComponent implements OnInit {
  // @ViewChild('content') el: ElementRef;
  modalShowQuoteDocumentAction = new EventEmitter<string | MaterializeAction>();
  constructor(public navService: NavbarService) { }

  ngOnInit() {
    this.navService.hide();
  }

  ngOnDestroy() {
    this.modalShowQuoteDocumentAction.emit({ action: 'modal', params: ['close'] });
  }

  openmodalShowQuoteDocument() {
    this.modalShowQuoteDocumentAction.emit({ action: 'modal', params: ['open'] });
  }

  saveQuotePDF() {
    let pdf = new jsPDF();
    // // pdf.setFillColor(204, 204,204,0);
    // pdf.rect(10, 10, 150, 160, "F");
    let element = document.getElementById('content');
    element.style.display = 'block';
    pdf.internal.scaleFactor = 3.75;

    let w = element.clientWidth;
    let h = element.clientHeight;
    let newCanvas = document.createElement('canvas');
    newCanvas.width = w * 6;
    newCanvas.height = h * 4;
    newCanvas.style.width = w + 'px';
    newCanvas.style.height = h + 'px';
    let context = newCanvas.getContext('2d');
    context.scale(2, 2);


    pdf.addHTML(element, {pagesplit: true, canvas: newCanvas}, function () {
      // var out = pdf.output('dataurlnewwindow'); // crashed if bigger file
      pdf.save('test1.pdf');
      element.style.display = 'none';
    });

  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/quotedocument/quotedocument.component.ts